module.exports = __webpack_public_path__ + "img/chinesecompany256.61755d04.png";